var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.hideHeader)?_c('a-layout-header',{class:[
    'layout-header',
    _vm.fixedHeader && 'layout-header__fixed',
    _vm.layoutMode === 'side' ? 'layout-header__light' : ("layout-header__" + _vm.menuTheme)
  ]},[_c('div',{staticClass:"header-left"},[_c('Logo',{attrs:{"collapsed":_vm.collapsed}}),_c('TopMenu',{attrs:{"mode":"horizontal"}})],1),_c('div',{staticClass:"header-right"},[_c('Actions')],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }